import { CookiebotVideoPlaceholder } from './components/cookiebot-video-placeholder';

const onDocumentReady = () => {
	const activeProvider = window?.QalaGdprCompliance?.settings?.activeCookieManager;

	// Cookiebot Vimeo Placeholder
	if ( activeProvider === 'cookiebot' ) {
		const elements = document.querySelectorAll( '[data-cookieblock-src]' );

		elements.forEach( element => {
			const cookiebotVimeoPlaceholder = new CookiebotVideoPlaceholder( element );
			cookiebotVimeoPlaceholder.init();
		} );
	}
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', onDocumentReady );
} else {
	onDocumentReady();
}
